import LoginService from '../services/LoginService';
import { replaceContextPath } from '../PathUtils';

const getSupportedLocales = (navigationData, locale) => {
    const supportedLocales = [];
    const { globalNav } = navigationData ?? {};
    const { menu } = globalNav ?? {};

    if (menu) {
        menu.forEach((m) => {
            if (m.locale) {
                let displayText;
                const { label, locale: supportedLocale } = m;

                if (label) {
                    displayText = label[locale];
                }
                supportedLocales.push({
                    locale: supportedLocale,
                    displayText,
                });
            }
        });
    }

    return supportedLocales;
};

const createForm = (config, e) => {
    const url = `${config.context}/app/initialLogin`;
    const form = document.createElement('form');
    form.style.display = 'none';

    const appendElement = (name, value) => {
        const element = document.createElement('INPUT');
        element.name = name;
        element.value = value;
        element.type = 'hidden';
        form.appendChild(element);
    };

    form.method = 'POST';
    form.action = url;

    appendElement('userid', e.username);
    appendElement('password', e.password);
    document.body.appendChild(form);

    return form;
};

const initPage = (config, isLegacy) => {
    const handler = (action) => {
        const elem = document.getElementById('loginApp');
        let { FiIdForMS, UserGuidForMS } = config;

        if (action === 'remove') {
            FiIdForMS = undefined;
            UserGuidForMS = undefined;
        }

        window.UserGuidForMS = UserGuidForMS;
        window.FiIdForMS = FiIdForMS;

        if (elem) {
            const method = action === 'remove' ? 'remove' : 'add';

            elem.classList[method]('login-renderer-wrapper');

            if (!window.AbortController) {
                elem.classList[method]('login-renderer-unsupported');
            }

            if (isLegacy) {
                elem.classList[method]('login-renderer-legacy');
            }
        }
    };

    return () => {
        handler('add');

        return () => {
            handler('remove');
        };
    };
};

const handleUserLockedState = (
    configParam,
    loginWidgetConfig,
    setLoadingMessages,
    isLegacy,
) => {
    return () => {
        const config = configParam;
        const { userLockedMessage } = config ?? {};

        // get userlocked from backend if there is a link
        // message from backend may be incorrect since it uses caps key which may not be in sync with login config
        if (
            config.error &&
            config.userLocked &&
            loginWidgetConfig &&
            userLockedMessage &&
            userLockedMessage.indexOf('<a') !== -1
        ) {
            setLoadingMessages(true);

            const { links } = loginWidgetConfig ?? {};

            const forgottenLoginLink = (links ?? []).find((link) => {
                return link.propertyName === 'forgottenLoginLinkLabel';
            });
            const isForgotPasswordEnabled = !!forgottenLoginLink;
            const { link: forgotPasswordLink = '' } = forgottenLoginLink ?? {};

            if (isLegacy) {
                const { di = {} } = window;
                const url = `${
                    di.env.context
                }/app/get-login-config-messages?forgotPasswordLink=${encodeURIComponent(
                    forgotPasswordLink,
                )}&isForgotPasswordEnabled=${isForgotPasswordEnabled}`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                    .then((msgResponse) => {
                        const contentType = msgResponse.headers.get(
                            'content-type',
                        );

                        if (
                            msgResponse.status === 200 &&
                            contentType &&
                            contentType.indexOf('application/json') !== -1
                        ) {
                            return msgResponse.json();
                        }

                        return Promise.reject();
                    })
                    .then((messages) => {
                        config.userLockedMessage = messages.userLockedMessage;
                        setLoadingMessages(false);
                    })
                    .catch((e) => {
                        console.log('error getting messages', e);
                        setLoadingMessages(false);
                    });
            } else {
                LoginService.getLoginConfigMessages({
                    isForgotPasswordEnabled,
                    forgotPasswordLink: isLegacy
                        ? forgotPasswordLink
                        : replaceContextPath(forgotPasswordLink, true),
                })
                    .then((messages) => {
                        config.userLockedMessage = messages.userLockedMessage;
                        setLoadingMessages(false);
                    })
                    .catch((e) => {
                        console.log('error getting messages', e);
                        setLoadingMessages(false);
                    });
            }
        }
    };
};

const WIDGET_RENDERER_MESSAGES = {
    loadErrorTitle: 'Error',
    loadErrorMessage: 'Error loading widget',
};

const prepareLoginHelpLocale = () => {
    const { locale } = window?.di?.env ?? {};

    if (locale && locale !== 'en_US')
        return `login_help_${locale.substring(0, 2)}`;

    return 'login_help';
};

export default {};
export {
    getSupportedLocales,
    WIDGET_RENDERER_MESSAGES,
    createForm,
    initPage,
    handleUserLockedState,
    prepareLoginHelpLocale,
};
